import { Component, ViewChild, ElementRef, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css']
})
export class AlertComponent {

  @ViewChild('notif') notif: ElementRef;
  message:string;
  constructor(
    public dialogRef: MatDialogRef<AlertComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.message = data.text;
     }

  closeNotification() {
    // this.notif.nativeElement.classList.remove('show-up');
    // this.notif.nativeElement.classList.add('close');
  }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/directive/alert/alert.component.ts